import { render, staticRenderFns } from "./TenantOverview.vue?vue&type=template&id=892ebbe0&scoped=true&"
import script from "./TenantOverview.vue?vue&type=script&lang=js&"
export * from "./TenantOverview.vue?vue&type=script&lang=js&"
import style0 from "./TenantOverview.vue?vue&type=style&index=0&id=892ebbe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892ebbe0",
  null
  
)

export default component.exports